<div class="logo_text {{classes}}" ><div class="text-emerald-400"><</div>{{text}}<div class="text-emerald-400">></div></div>
